import * as React from "react";
import PropTypes from 'prop-types';

const SvgIconPhone = props => {
  if (props.id !== "_svgiconphone") {
    throw new Error('SVG requires <Icon> component as a parent, e.g. <Icon><SvgLogo></Icon>');
  }

  return <svg viewBox="0 0 30 30" {...props}><path d="M12.379 7.819a5.935 5.935 0 015.927 5.928.746.746 0 01-1.492 0 4.44 4.44 0 00-4.435-4.435.746.746 0 110-1.493zm9.163 7.362a.746.746 0 01-.746-.746 9.019 9.019 0 00-2.699-6.47c-1.737-1.713-4.055-2.656-6.527-2.656a.746.746 0 010-1.493c2.867 0 5.558 1.096 7.575 3.086a10.5 10.5 0 013.143 7.533.746.746 0 01-.746.746zM10.803 0C19.183 0 26 6.818 26 15.199a.746.746 0 01-1.493 0c0-7.558-6.147-13.706-13.704-13.706a.746.746 0 110-1.493zm12.043 20.364c.413.312.66.8.66 1.335 0 .518-.233.993-.624 1.306l-.02.02c-1.448 1.332-3.353 2.863-5.245 2.863-2.445 0-6.316-.618-11.669-5.96-4.426-4.416-6.207-7.98-5.77-11.55C.352 6.576 1.45 4.38 1.933 3.55c.272-.616.924-1.052 1.684-1.052.582 0 1.025.295 1.349.51l.11.074 3.442 3.302a2.856 2.856 0 011.02 2.156c0 .795-.293 1.548-.806 2.073l-1.063 1.14a15.45 15.45 0 002.603 3.463 18.222 18.222 0 003.829 2.911l1.58-1.444a2.263 2.263 0 011.579-.652c.586 0 1.146.231 1.581.653l4.006 3.68z" /></svg>;
};

SvgIconPhone.displayName = "_svgiconphone";
SvgIconPhone.propTypes = {
  id: PropTypes.string
};
SvgIconPhone.defaultProps = {
  id: ''
};
export default SvgIconPhone;